import cloneDeep from 'lodash/cloneDeep'
import BigNumber from 'bignumber.js'
import type { BpCartItem, BpCartItemModifier } from '~/definitions/AllDefinitions'

export function calcSubtotal(items: BpCartItem[]): number {
  if (!(items && items.length)) {
    return 0
  }
  let basePrice = new BigNumber(0)
  items.forEach((cartItem: BpCartItem) => {
    let itemPrice = new BigNumber(0)
    if (typeof cartItem.price !== 'undefined') {
      itemPrice = itemPrice.plus(cartItem.price)
      if (cartItem.modifiers && cartItem.modifiers.length) {
        cartItem.modifiers.forEach((modifier) => {
          if (typeof modifier.price !== 'undefined') {
            itemPrice = itemPrice.plus(modifier.price)
          }
        })
      }
    }
    const cartItemQuantity = (new BigNumber(cartItem.quantity)).times(itemPrice)
    basePrice = basePrice.plus(cartItemQuantity)
  })
  return basePrice.toNumber()
}

export function cartItemSubTotal(item: BpCartItem) {
  let total = new BigNumber(0)
  if (typeof item.price !== 'undefined') {
    // total += item.price
    total = total.plus(item.price)
  }
  const options = getCartOptions(item)
  const extras = getCartExtras(item)
  if (options?.length) {
    for (let i = 0; i < options.length; i++) {
      total = total.plus(options[i].price)
    }
  }
  if (extras.length) {
    extras.forEach((modifier) => {
      if (typeof modifier.price !== 'undefined') {
        // total += modifier.price
        total = total.plus(modifier.price)
      }
    })
  }
  return total.times(item.quantity).toNumber()
}

export function getCartOptions(item: BpCartItem) {
  return item.modifiers?.length
    ? item.modifiers.filter((modifier) => {
        return modifier.type === 'options'
      })
    : []
}

export function getCartExtras(item: BpCartItem) {
  if (item.modifiers && item.modifiers.length) {
    const items = item.modifiers.filter((modifier) => {
      return modifier.type === 'extras'
    })
    return items && items.length ? cloneDeep(items) : [] as BpCartItemModifier[]
  } else {
    return [] as BpCartItemModifier[]
  }
}
